/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Add_Contract_Addons_Included_NoteInputs */



/**
* | output |
* | --- |
* | "Add-ons are part of the contract: covered by the purchase order, not invoiced monthly, and fixed for the term." |
*
* @param {Partner_Add_Contract_Addons_Included_NoteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_add_contract_addons_included_note = /** @type {((inputs?: Partner_Add_Contract_Addons_Included_NoteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Add_Contract_Addons_Included_NoteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zusatzmodule sind Teil des Vertrags: durch die Bestellung abgedeckt, nicht monatlich berechnet und für die Laufzeit festgelegt.")
	return /** @type {LocalizedString} */ ("Add-ons are part of the contract: covered by the purchase order, not invoiced monthly, and fixed for the term.")
});